import React from "react";
import MadeWithLove from 'react-made-with-love';

export const Footer = () => {
    return (
        <MadeWithLove by="Cincin" emoji/>
    )
}